import { api } from "../services/index"

export function getApplications() {
  return api.get(`/apps`)
}

export function getApplication(appID) {
  return api.get(`/apps/${appID}`)
}

export function editApplication(appID, data) {
  return api.patch(`/apps/${appID}`, data)
}

export function addApplication(appID, data) {
  return api.put(`/apps/${appID}`, data)
}

export function deleteApplication(appID) {
  return api.delete(`/apps/${appID}`)
}

export function deleteApplicationUsers(appID, data) {
  return api.post(`/apps/${appID}/users/batch-delete`, data)
}

export function addApplicationUsers(appID, data) {
  return api.post(`/apps/${appID}/users/batch-add`, data)
}

export function getApplicationUsers(appID) {
  return api.get(`/apps/${appID}/users`)
}

export function deleteApplicationGroups(appID, data) {
  return api.post(`/apps/${appID}/groups/batch-delete`, data)
}

export function addApplicationGroups(appID, data) {
  return api.post(`/apps/${appID}/groups/batch-add`, data)
}

export function getApplicationGroups(appID) {
  return api.get(`/apps/${appID}/groups`)
}

export function getContracts(appID) {
  return api.get(`/apps/${appID}/contracts`)
}
